var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "searchResultModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable",
        },
        [
          _c("ValidationObserver", {
            ref: "searchResultRef",
            staticClass: "modal-content",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("查詢結果全選 "),
                        _c("strong", { staticStyle: { "font-size": "15px" } }, [
                          _vm._v("共" + _vm._s(_vm.totalPerson) + "人"),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _vm._v("功能"),
                          ]),
                          _c("ValidationProvider", {
                            attrs: {
                              tag: "section",
                              name: "功能",
                              rules: "required",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "w-100",
                                          attrs: { placeholder: "請選擇" },
                                          model: {
                                            value: _vm.modalValue.action,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.modalValue,
                                                "action",
                                                $$v
                                              )
                                            },
                                            expression: "modalValue.action",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "標記為過期",
                                              value: 0,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "移除過期標記",
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "履歷移除",
                                              value: 2,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "維護廠別",
                                              value: 3,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.modalValue.action === 3
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("廠別"),
                              ]),
                              _c("ValidationProvider", {
                                attrs: { name: "廠別", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                multiple: "",
                                                placeholder: "請選擇",
                                              },
                                              model: {
                                                value:
                                                  _vm.modalValue.chooseFactory,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.modalValue,
                                                    "chooseFactory",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "modalValue.chooseFactory",
                                              },
                                            },
                                            _vm._l(
                                              _vm.factoryOptions,
                                              function (factory) {
                                                return _c("el-option", {
                                                  key: factory.Guid,
                                                  attrs: {
                                                    label: factory.Name,
                                                    value: factory.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v(" 關閉 ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return handleSubmit(_vm.saveData)
                            },
                          },
                        },
                        [_vm._v(" 儲存 ")]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }